export enum CardsFiltrosEnum {
  PENDENCIAS_EQUIPE = 1,
  MINHAS_PENDENCIAS = 2,
  PENDENCIA_OUTROS = 3,
  AGUARDANDO_EFETUACAO = 4,
}
